var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0605469,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#C6F6D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4767 45.2692L54.5417 24.2019L57.7845 27.4423L33.4767 51.75L18.8926 37.1659L22.133 33.9254L33.4767 45.2692Z",
    fill: "#25855A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSuccess);
export default __webpack_public_path__ + "static/media/big-success.b245a4e1034986fa0e05431a6af40c0c.svg";
export { ForwardRef as ReactComponent };